import Cookies from 'universal-cookie';
import { CURRENT_PRODUCT } from './constants';
import { setCookies } from './cookies';

export const getCurrentProduct = () : string => {
  const cookies = new Cookies();
  return cookies.get(CURRENT_PRODUCT);
};

export const updateCookieCurrentProduct = (currentProduct : string) : void => {
  if(!currentProduct)
    return;

  setCookies(CURRENT_PRODUCT, currentProduct);
};